import React from "react";
import { Drawer, Group, ActionIcon, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { utils, ROOT_BASE_URL } from "../../../utils/globalVariables";

import ImageLightBox2 from "../../../components/general/ImageLightBox2";
import VideoPlayerModal from "../../../components/general/VideoPlayerModal";
import StepNotaDibatalkan from "../../../components/utilities/StepNotaDibatalkan";

const ProjectQuickView = ({
    stateShow,
    fnShow,
    stateData
}) => {
    // const utilsRef = React.useRef({
    //     userAccess: [
    //         // role.owner.subLevel.owner.slugSubLevel,
    //         // role.admin.subLevel.admin_kepala.slugSubLevel,
    //         // role.admin.subLevel.admin_staf.slugSubLevel,
    //     ]
    // })

    const [data, setData] = React.useState({
        imageLightboxImages: '',
        imageLightboxTitle: '',
        imageLightboxIndex: '',
        imageLightboxFieldName: '',
        imageLightboxShow: false,

        mediaURL: '',
        mediaTitle: '',
        mediaShow: false
    });

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={() => fnShow(false)}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={() => fnShow(false)}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Quick View</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                {stateData.data &&
                    <StepNotaDibatalkan
                        stateURI1={stateData.data.project_id}
                        stateUtilsRef={{
                            projectProcess: stateData.data.project_process,
                            projectIsCancel: '0',
                        }}

                        fnRefreshNotaIndex={() => { }}

                        fnRefreshHistory={() => { }}

                        fnClickPhoto={(object) => setData(d => ({
                            ...d,
                            imageLightboxImages: object.images,
                            imageLightboxTitle: object.title,
                            imageLightboxIndex: object.index,
                            imageLightboxFieldName: object.fieldName,
                            imageLightboxShow: true,
                        }))}

                        stateShowMediaQC={true}
                        fnClickMediaImageVideo={(object) => {
                            object.type === utils.mediaQCType.image.value ?
                                setData(d => ({
                                    ...d,
                                    imageLightboxImages: object.images,
                                    imageLightboxTitle: object.title,
                                    imageLightboxIndex: object.index,
                                    imageLightboxFieldName: object.fieldName,
                                    imageLightboxShow: true,
                                }))
                                :
                                setData(d => ({
                                    ...d,
                                    mediaURL: object.name,
                                    mediaTitle: object.title,
                                    mediaShow: true,
                                }))
                        }}

                        fnCloseDrawer={() => fnShow(false)}
                    />
                }
            </Drawer>

            <ImageLightBox2
                stateImages={Array.isArray(data.imageLightboxImages) && (data.imageLightboxImages.length > 0) ? data.imageLightboxImages.map(key => ROOT_BASE_URL + key[data.imageLightboxFieldName]) : []}

                stateTitle={data.imageLightboxTitle}
                stateSelectedIndex={data.imageLightboxIndex}
                stateShow={data.imageLightboxShow}
                fnShow={() => setData(d => ({ ...d, imageLightboxShow: false }))}
            />

            <VideoPlayerModal
                stateURL={data.mediaURL}
                stateTitle={data.mediaTitle}
                stateShow={data.mediaShow}
                fnShow={() => setData(d => ({ ...d, mediaShow: false }))}
            />
        </React.Fragment>
    )
}

export default React.memo(ProjectQuickView);